// ChatPaginationContext.js
import React, { createContext, useContext, useState } from 'react';

const ChatPaginationContext = createContext();

export const PaginationProvider = ({ children }) => {
  const [index, setIndex] = useState(0);
  const [size, setSize] = useState(15); // Default page size

  const value = {
    index,
    setIndex,
    size,
    setSize,
    nextPage: () => setIndex(prev => prev + 1),
    prevPage: () => setIndex(prev => Math.max(0, prev - 1)),
    resetPage: () => setIndex(0),
    goToPage: (pageNum) => setIndex(pageNum),
    updateSize: (newSize) => {
      setSize(newSize);
      setIndex(0); // Reset to first page when size changes
    }
  };

  return (
    <ChatPaginationContext.Provider value={value}>
      {children}
    </ChatPaginationContext.Provider>
  );
};

export const useChatPagination = () => {
  const context = useContext(ChatPaginationContext);
  if (!context) {
    throw new Error('useChatPagination must be used within PaginationProvider');
  }
  return context;
};